<template>
    <div>
        <header-component></header-component>

        <account-quick-panel-component></account-quick-panel-component>

        <!-- <transaction-history-component :hidePagination="true" :applyLimit="3" :order="'desc'" :showViewAllButton="true" ></transaction-history-component> -->

        <!-- <category-offers-component class="bg-grey"></category-offers-component>-->
<!--        <activated-offers-component-->
<!--            v-if="activatedOffers.length > 0"-->
<!--            :activatedOffers="activatedOffers"-->
<!--        ></activated-offers-component>-->

        <!-- <faqs-component></faqs-component> -->

        <footer-component></footer-component>
    </div>
</template>

<script>
    import AccountQuickPanelComponent from './AccountQuickPanelComponent.vue';
    import HeaderComponent from './HeaderComponent.vue';
    import CategoryOffersComponent from './CategoryOffersComponent.vue';
    import FooterComponent from './FooterComponent.vue';
    import ActivatedOffersComponent from "./ActivatedOffersComponent.vue";

    export default {
        components: {
            HeaderComponent,
            AccountQuickPanelComponent,
            CategoryOffersComponent,
            FooterComponent,
            ActivatedOffersComponent,

        },
        name: "MyAccountComponent",

        data(){
            return {
                activatedOffers: [],
            }
        },
        methods : {
            getActivatedOffers(type = null, category = null) {
                let payload = {
                    PageNumber: 1,
                    ItemsPerPage: 20,
                    offset: 0,
                    filter : "activated",
                    ActiveSc : 'ACTIVATED_STATEMENT_CREDIT'
                };


                axios.post(this.apiEndPoints.matchedOffers, payload)
                    .then((response) => {
                        let offers = response?.data?.Response?.Items?.MatchedOffer;

                        if (offers !== undefined) {
                           this.activatedOffers =  offers;
                        }
                    })
                    .catch((error) => {
                        // console.error(error, 'here');
                        // console.error(error.status,'here')

                        if (error.response.status == 401 || error.response.status == 419) {
                            this.$router.push({name : 'sign_in'});
                        }
                    });
            },
        },

        mounted() {
            //this.getActivatedOffers();
        }

    }
</script>

<style scoped>

</style>
